<div class="app-layout">

  <!-- Backdrop mobile -->
  <div
    class="sidebar-backdrop"
    [class.sidebar-backdrop--visible]="isMobileSidebarOpen"
    (click)="toggleSidebar()"
  ></div>

  <!-- Sidebar -->
  <div
    class="app-layout__sidebar"
    [class.app-layout__sidebar--open]="isMobileSidebarOpen"
  >
    <app-sidebar
      [collapsed]="collapsed"
      [disableClickOutside]="isMobile"
      (clickOutside)="handleClickOutside()"
      (oneMenuIsClicked)="onOneMenuClicked()"
    />
  </div>

  <!-- Contenu principal -->
  <div class="app-layout__content">
    <div class="app-layout__header">
      <app-header
        [collapsed]="collapsed"
        [sidebarOpen]="isMobileSidebarOpen"
        (toggleSidebar)="toggleSidebar()"
      />
    </div>
    <main class="app-layout__main">
      <router-outlet></router-outlet>
    </main>
  </div>

</div>